export class EntCheckpoint {
  id: number = 0;
  nameRu: string = "";
  nameKy: string = "";
  address: string = "";
  type: string = "";
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;
}
